import { Badge } from '@/components/ui/badge';

export const SIDEBAR_MENU_ITEMS = [
  {
    name: 'Overview',
    url: 'overview'
  },
  {
    name: 'Highlights & Risks',
    url: 'highlights-and-risks'
  },
  {
    name: 'Transaction Structure',
    url: 'transaction-structure'
  },
  {
    name: 'Company',
    url: 'company'
  },
  {
    name: 'Financials',
    url: 'financials'
  },
  {
    name: 'Talent',
    url: 'talent'
  },
  {
    name: 'Industry',
    url: 'industry'
  },
  {
    name: 'Market Position',
    url: 'market-position'
  },
  {
    name: 'Appendices',
    url: 'appendices'
  },
  {
    name: 'Deal Score',
    url: 'deal-score'
  },
  {
    name: 'Allocations',
    url: 'allocations'
  },
  {
    badge: (numberCompleted: number) => (
      <Badge className="text-dark-blue-primary-smc-100 bg-dark-blue-primary-smc-500">
        {numberCompleted}
      </Badge>
    ),
    isDisabled: (hasDDProject: boolean) => !hasDDProject,
    isDisabledTooltip:
      "There's no due diligence process for this deal yet. Due diligence is created when a deal is marked Active.",
    name: 'Due Diligence',
    url: 'due-diligence'
  },
  {
    name: 'Feedback',
    url: 'feedback'
  },
  {
    name: 'Deal Calculator',
    url: 'deal-calculator'
  },
  {
    name: 'IC Voting',
    url: 'ic-voting'
  }
];
